import { render } from "./OfficialLogin.vue?vue&type=template&id=58bce415&scoped=true"
import script from "./OfficialLogin.vue?vue&type=script&lang=js"
export * from "./OfficialLogin.vue?vue&type=script&lang=js"

import "./OfficialLogin.vue?vue&type=style&index=0&id=58bce415&scoped=true&lang=less"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bce415"]])

export default __exports__